import React, { useEffect, useState } from 'react';
import ContentHeader from '../../parts/ContentHeader';
import MainContainer from '../../parts/MainContainer';
import { httpRequest, httpAuthHeaders } from '../../../helpers/httpService';
import helpers from '../../../helpers/helpers';
import appConfig from '../../../config/env';
import Swal from 'sweetalert2';
import { Outlet, Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown'
import ReactPaginate from 'react-paginate';
import Loader from '../../parts/Loader';
import DropDownSelection from '../../elements/DropDownSelection';
import store from '../../../helpers/store';
 
function ServiceRequestDashboard ({viewer = 'admin', menu = 'service-request-main', page_title = "Service Request Main"}){
    const [service_request_list, setServiceRequest] = useState([]);
    const [all_data, setAllData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [item_list, setItemList] = useState([]);
    const [search_key, setSearchKey] = useState('');
    const [selected_status, setStatus] = useState('');

    useEffect(() => {
        let technician_id = ''
        if(viewer == 'technician'){
            technician_id = helpers.getEmployeeID();
        }
        //Mounted
        getDataList('', '')
    }, []);

    useEffect(() => {
        let technician_id = ''
        if(viewer == 'technician'){
            technician_id = helpers.getEmployeeID();
        }

        getDataList('', '')
    }, [viewer]);

    function getDataList(page = '', search = '', get_status = ''){
        let filter = '?'

        if(page){
            filter += 'page='+page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        
        let technician_id = ''
        if(viewer == 'technician'){
            technician_id = helpers.getEmployeeID();
            
            if(technician_id){
                filter += 'technician_id='+technician_id+'&'
            }
        }

    
        const queryString = window.location.search ?? '';
        const urlParams = new URLSearchParams(queryString);
        let param = urlParams.get('filter') ?? '';
        // if(queryString){
        //     param = urlParams.get('filter')
        // }
        if(param){
            filter += 'filter_by=status&filter='+param+'&'
        }

        if(get_status){
            filter += 'filter_by=status&filter='+get_status+'&'

            console.log(search_key)

            if(search_key){
                filter += 'search='+search_key+'&'
            }
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.getUrl('admin/service-request'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setServiceRequest(res.data)
                setAllData(res)
                setLoading(0)
                table_items(res.data)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    

    function search(e){
        let { value, name } = e.target;

        setSearchKey(value)
        getDataList('', value)
        setStatus('')
    }

    function filterStatus(e) {
        let { value, name } = e.target;

        getDataList('','', value)
        setStatus(value)
        // if (e.target.type === "checkbox") {
        //     if (e.target.checked) {
        //         value = 1;

        //         if(name == 'warranty_status') value = 'active'
        //     } else {
        //         value = 0;

        //         if(name == 'warranty_status') value = 'expired'
        //     }
        // }
        // else if (e.target.type === "file") {
        //   value = e.target.files[0]
        // }

        // let new_state = { [name]: value }

        // setForm({ ...form_data, ...new_state });
    }

    function table_items(data){
        let table_items = [];
        if (Object.keys(data).length > 0) {
            table_items = Object.entries(data).map(([key, data]) => {
                return (<tr key={data.id}>
                            <td>{data.service_no}</td>
                            <td>{`${data.first_name} ${data.last_name}`}</td>
                            <td>{`${data.appliance_type} | ${data.brand}`}</td>
                            <td>{data.model_no}</td>
                            <td>{data.created_at}</td>
                            <td>{data.record_type}</td>
                            <td>{helpers.displayStatusBadge(data.status)}</td>
                            <td className='text-center'>
                                <Dropdown className='custom-dropdown'>
                                <Dropdown.Toggle variant="secondary" size="sm" id={"dropdown-actions-"+key}></Dropdown.Toggle>

                                <Dropdown.Menu align="end">
                                    {displayDropItems(data)}
                                </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>)
            })
        }
        else{
            table_items = <tr>
                <td colSpan="8" className='text-center'>No available data</td>
            </tr>
        }

        
        setItemList(table_items)

        //return table_items;
    }

    function updateStatus(service_id, status, visibility = 'private'){
        let title = ''
        let text = 'Are you sure you want to continue?'

        if(status === 'in-progress'){
            title = "Start Service Repair"
        }
        else if(status === 'repair-completed'){
            title = "Completed Repair"
        }
        else if(status === 'for-release'){
            title = "Ready for Release"
        }
        else if(status === 'completed'){
            title = "Released Unit"
        }
        else if(status === 'return-to-owner'){
            title = "Return to Owner"
            text = 'This action cannot be reversible. Are you sure you want to continue?'
        }
        else if(status === 'cancelled'){
            title = "Cancel Service"
            text = 'This action cannot be reversible. Are you sure you want to continue?'
        }

        Swal.fire({
            title: title,
            text: text,
            //icon: "warning",
            confirmButtonText: "OK",
            showCancelButton: true,
            closeOnCancel: true
        })
        .then((result) => {
            if (result.isConfirmed) {
                setLoading(1)

                const url = helpers.getUrl('admin/service-request/'+service_id+'/update-status')
                httpRequest(url, "POST", {
                    postdata: {
                        'status' : status,
                        'visibility': visibility
                    },
                }, true)
                    .then((res) => {
                        setLoading(0)
                        getDataList()
                    })
                    .catch((err) => {
                        console.log(err)
                        setLoading(0)
        
                        Swal.fire({
                            title: "Error!",
                            text: err.message,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }); 

            }
        })
    }

    function displayDropItems(data){
        let items = []
        //items.push(<Dropdown.Item key="view" as={Link} to={`/e/${data.slug}`}>View</Dropdown.Item>)

        //items.push(<Dropdown.Divider key="divider1" />)
        //items.push(<Dropdown.Item key="export-trans" onClick={(e) => exportReport(data, 'transactions')}>Export Transactions</Dropdown.Item>)
        //items.push(<Dropdown.Item key="export-part" onClick={(e) => exportReport(data, 'participants')}>Export Participants</Dropdown.Item>)
        //items.push(<Dropdown.Divider key="divider2" />)

        
        if(data.status === 'created' || data.status === 'for-assessment'|| data.status == 'unit-checked'){
            items.push(<Dropdown.Item key="edit" as={Link} to={`/service-request/${data.id}/edit`}>Edit Request</Dropdown.Item>)
        }
        else{
            items.push(<Dropdown.Item key="edit" as={Link} to={`/service-request/${data.id}/details`}>View Service Request</Dropdown.Item>)
        }

        if(data.status === 'for-assessment'){
            items.push(<Dropdown.Divider key="divider-1" />)
            items.push(<Dropdown.Item key="transactions" as={Link} to={`/service-request/${data.id}/edit-schedule`}>Edit Schedule</Dropdown.Item>)
            items.push(<Dropdown.Item key="add-assessment" as={Link} to={`/service-request/${data.id}/add-assessment`}>Add Assessment</Dropdown.Item>)
          //items.push(<Dropdown.Item key="cancel" onClick={(e) => changeStatus(data.id, 'cancelled')}>Cancel</Dropdown.Item>)
        }
        else if(data.status === 'unit-checked'){
            items.push(<Dropdown.Divider key="divider-2" />)
            items.push(<Dropdown.Item key="add-assessment" onClick={(e) => updateStatus(data.id, 'in-progress', 'public')} className='text-info'>Start Repair</Dropdown.Item>)
            items.push(<Dropdown.Item key="add-assessment" as={Link} to={`/service-request/${data.id}/edit-assessment`}>Edit Assessment</Dropdown.Item>)
            items.push(<Dropdown.Item key="job-order" as={Link} to={`/export/job-order/${data.id}/view`}>View Job Order</Dropdown.Item>)
        }
        else if(data.status === 'approved-quoation'){
            items.push(<Dropdown.Divider key="divider-3" />)
            items.push(<Dropdown.Item key="add-assessment" onClick={(e) => updateStatus(data.id, 'in-progress', 'public')} className='text-info'>Start Repair</Dropdown.Item>)
        }
        else if(data.status === 'in-progress'){
            items.push(<Dropdown.Divider key="divider-3" />)
            items.push(<Dropdown.Item key="add-assessment" onClick={(e) => updateStatus(data.id, 'repair-completed', 'public')} className='text-success'>Repair Completed</Dropdown.Item>)
            items.push(<Dropdown.Item key="job-order" as={Link} to={`/export/job-order/${data.id}/view`}>View Job Order</Dropdown.Item>)
        }
        else if(data.status === 'repair-completed'){
            items.push(<Dropdown.Divider key="divider-3" />)
            items.push(<Dropdown.Item key="add-assessment" onClick={(e) => updateStatus(data.id, 'for-release', 'public')} className='text-info'>Unit For Release</Dropdown.Item>)
            items.push(<Dropdown.Item key="job-order" as={Link} to={`/export/job-order/${data.id}/view`}>View Job Order</Dropdown.Item>)
        }
        else if(data.status === 'for-release'){
            items.push(<Dropdown.Divider key="divider-3" />)
            items.push(<Dropdown.Item key="for-release" as={Link} to={`/service-request/${data.id}/release`}>Release Unit</Dropdown.Item>)
            items.push(<Dropdown.Item key="job-order" as={Link} to={`/export/job-order/${data.id}/view`}>View Job Order</Dropdown.Item>)
        }
        else if(data.status === 'created'){
            items.push(<Dropdown.Divider key="divider-4" />)
            items.push(<Dropdown.Item key="created" as={Link} to={`/service-request/${data.id}/new-schedule`}>Add Schedule</Dropdown.Item>)
        }
        else if(data.status === 'completed'){
            items.push(<Dropdown.Item key="job-order" as={Link} to={`/export/job-order/${data.id}/view`}>View Job Order</Dropdown.Item>)
        }

        if(data.status !== 'cancelled' && data.status !== 'return-to-owner' && data.status !== 'completed' && data.status !== 'for-release' && data.status !== 'released'){
            items.push(<Dropdown.Divider key="divider-5" />)
            items.push(<Dropdown.Item key="return-to-owner" onClick={(e) => updateStatus(data.id, 'return-to-owner', 'public')} className='text-primary'>Return To Owner</Dropdown.Item>)
            items.push(<Dropdown.Item key="cancel" onClick={(e) => updateStatus(data.id, 'cancelled', 'public')} className='text-danger'>Cancel Request</Dropdown.Item>)

        }

        return items;
    }

    // Invoke when user click to request another page.
    const handlePageClick = ({ selected: event }) => {
        getDataList(event + 1, search_key)
    };

    function handleExport(){
        const url = helpers.getUrl('admin/report/export')
        
        const today = new Date();
        const month = today.getMonth() + 1;
        const date = today.getFullYear() + '-' + month + '-' + today.getDate() + '_' +  today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
        const file_name = 'export-service-service' + '_' + date + '.xlsx';
        
        setLoading(1)
        
        fetch(url, {
            method: 'GET',
            headers: httpAuthHeaders(),
        })
        .then((res) => {
          if(res.ok) {
            return res.blob();
          }
          
          const json = res.json();
          const status_code = res.status;
  
          if (!res.ok) {
              let errorCode = json.error_code ? json.error_code : 'unknown';
              let message = json.message ? json.message : (res.statusText ? res.statusText : 'Request failed');
              let data = json.error ? json.error: '';
              let status = json.status ? json.status: '';
              let error = { data: data, message: message, error_code: errorCode, status_code: status_code, status: status };
  
              if (status_code === 422) error = { ...error, ...json };
  
              return Promise.reject(error);
          }
        })
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.setAttribute("href", url);
            a.download = file_name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
            setLoading(0);
        })
        .catch(err => {
          Swal.fire("Error", "Export failed", "error");
          setLoading(0);
        });
    }

    return (
        <MainContainer page_title={page_title} menu={menu}>
            <div className="container-fluid" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search" onChange={search} />
                                    <span className="input-group-text" id="basic-addon2"><i className="fas fa-search" /></span>
                                </div>
                            </div>
                            <div className="col-md-3">                                            
                                <DropDownSelection
                                    tagClass="form-control"
                                    name='status' 
                                    placeholder='Select Status'
                                    value={selected_status}  
                                    onChange={filterStatus}
                                    optionList={store.service_status}
                                    optionProps ={{value:'id', label:'name'}}
                                />

                            </div>
                            <div className="col-md-5 text-right mt-3 mt-md-0">
                                <button className='btn btn-info mr-3' to="/service-request/new" type='button' onClick={handleExport}><i className="fas fa-file-excel mr-2" />Export</button>
                                {helpers.checkPermissions(["all-access", "service-request-created"]) ? <Link className='btn btn-primary' to="/service-request/new"><i className="fas fa-plus mr-2" />Create</Link> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0 table-responsive">
                        <table className="table table-sm table-striped">
                            <thead>
                                <tr>
                                <th>Ref No.</th>
                                <th>Customer Name</th>
                                <th>Item</th>
                                <th>Model</th>
                                <th>Date</th>
                                <th>Type</th>
                                <th style={{width: 40}}>Status</th>
                                <th style={{width: 30}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* {table_items(service_request_list)} */}
                                {item_list}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer d-flex justify-content-center">
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel="Next"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={all_data.last_page}
                            previousLabel="Previous"
                            className="pagination mb-0"
                            pageClassName="page-item"

                            activeClassName="active"

                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                        />
                    </div>
                </div>
            </div>
        </MainContainer>
    )
}
 
export default ServiceRequestDashboard;